// apps/web/src/components/landing-v2/proofs/SpreadProof.tsx
/** Theme 01 / 3- and 5-card spreads — Cosmic-only.
 *  Three card arts laid side-by-side, middle card lifted.
 *  Reference: handoff .mm-spread. */
const CARDS = [
  { src: '/cards/the-moon.webp', alt: '' },
  { src: '/cards/the-star.webp', alt: '' },
  { src: '/cards/the-sun.webp', alt: '' },
]

export function SpreadProof() {
  return (
    <div className="absolute inset-0 flex flex-row items-center justify-center gap-2 p-[18px]">
      {CARDS.map((c, i) => (
        <div
          key={c.src}
          className="aspect-[2/3] w-[18%] overflow-hidden rounded border border-hairline"
          style={{
            background: 'var(--color-deep-purple)',
            transform: i === 1 ? 'translateY(-10px)' : undefined,
            boxShadow: '0 12px 24px -8px rgba(0,0,0,0.6)' /* theme-audit: bespoke shadow */,
          }}
        >
          <img
            src={c.src}
            alt={c.alt}
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </div>
      ))}
    </div>
  )
}
